import React from "react";
// TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import OpcUaTextField from "./OpcUaTextField";

/**
 * Connection-scoped OPC UA settings on the adapter CDO. The endpoint URL
 * itself moved to the Channel (see `StepChannels.tsx`'s
 * `isValidOpcUaEndpointUrl`/`opcUaEndpointUrl` field) since the connection
 * target belongs to the channel, not the per-adapter mapping config
 * (flatbuffer_schemas 0697cf91).
 */
export default function ConnectionEditor({
  applicationName,
  onChangeApplicationName,
  applicationUri,
  onChangeApplicationUri,
  productUri,
  onChangeProductUri,
}: {
  applicationName: string;
  onChangeApplicationName: (value: string) => void;
  applicationUri: string;
  onChangeApplicationUri: (value: string) => void;
  productUri: string;
  onChangeProductUri: (value: string) => void;
}) {
  const [t] = useTranslation("global");

  return (
    <div className="container" style={{ width: "100%", maxWidth: "none" }}>
      <div className="row">
        <div className="col-12 mt-3">
          <OpcUaTextField
            label="Application Name"
            value={applicationName}
            onChange={onChangeApplicationName}
            tooltip={t("general.opcUaApplicationNameHelp")}
          />
        </div>
        <div className="col-12 col-md-6 mt-3">
          <OpcUaTextField
            label="Application URI"
            value={applicationUri}
            onChange={onChangeApplicationUri}
            tooltip={t("general.opcUaApplicationUriHelp")}
            placeholder="urn:liftnet:opcua:client"
          />
        </div>
        <div className="col-12 col-md-6 mt-3">
          <OpcUaTextField
            label="Product URI"
            value={productUri}
            onChange={onChangeProductUri}
            tooltip={t("general.opcUaProductUriHelp")}
            placeholder="urn:liftnet:opcua"
          />
        </div>
      </div>
    </div>
  );
}
